import { render, staticRenderFns } from "./insights.vue?vue&type=template&id=a4ff7050&scoped=true&lang=pug&"
import script from "./insights.vue?vue&type=script&lang=js&"
export * from "./insights.vue?vue&type=script&lang=js&"
import style0 from "./insights.vue?vue&type=style&index=0&id=a4ff7050&scoped=true&lang=scss&"
import style1 from "./insights.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ff7050",
  null
  
)

export default component.exports